import React from 'react';
import { getSupportTicketDetails } from '@css-xp/ppc-utils';

export const SupportTicketNumber = ({ supportTicket }: { supportTicket: string }) => {
  const supportTicketDetails = getSupportTicketDetails(supportTicket);
  const supportTicketUrl = supportTicketDetails.supportTicketUrl;
  const supportTicketNumber = supportTicketDetails.supportTicketNumber;
  const isValidUrl = supportTicketDetails.isValidUrl;
  const redirectUrl = supportTicketDetails.redirectUrl;

  return isValidUrl ? (
    <a href={redirectUrl} target="_blank">
      {supportTicketNumber || supportTicketUrl}
    </a>
  ) : (
    <span>{supportTicketUrl}</span>
  );
};
